
import { PageList } from "../src/list/PageList";
import { Assets } from "../src/list/Assets";
import { homeRows } from "../src/lib/gameData";
import { homeLooks } from "../src/lib/fashionLibrary";
import FashionHomeRow from "../src/components/FashionHomeRow";
import dynamic from 'next/dynamic';
import CategoryChips from '../src/components/CategoryChips';
import QuickNav from '../src/components/QuickNav';

const Headcom = dynamic(() => import('../src/components/Headcom'), {  });
const CatBtn = dynamic(() => import('../src/components/CatBtn'), {  });
const HomeDis = dynamic(() => import('../src/Description/HomeDis'), {  });
const FooterDis = dynamic(() => import('../src/Description/FooterDis'), {  });
const CookieCom = dynamic(() => import('../src/components/CookieCom'), {  });
const FooterCom = dynamic(() => import('../src/components/FooterCom'), {  });
const Game_Components = dynamic(() => import('../src/components/Game_Components'), {  });
const BlackScreen = dynamic(() => import('../src/components/BlackScreen'), {  });
const Snow_fx = dynamic(() => import('../src/fx/Snow_fx'), {  });
// Personalised rows read localStorage after mounting; the server HTML carries their loading skeleton
// (shown from the first paint to returning visitors only, see RowsSkeleton)
const PersonalRows = dynamic(() => import('../src/components/PersonalRows'));

export async function getStaticProps() {
  return { props: { rows: homeRows({ home: true }), fashion: homeLooks() } };
}

export default function HomePage({ rows, fashion }) {

  return (
    <>
      <div className="app_cont_game">
        <Headcom
          title={PageList[0].title}
          s_dis={PageList[0].s_dis}
          path={PageList[0].path[1] + PageList[0].path[0]}
          thumb={PageList[0].thumb}
          logo_16={Assets[0].logo_16}
          // logo_32={Assets[0].logo_32}
          logo_192={Assets[0].logo_192}
          logo_270={Assets[0].logo_270}
          logo_512={Assets[0].logo_512}
        />
        <div>

          <BlackScreen />

          <div className="game-root">
            <div className="container">
            <CategoryChips />
            <QuickNav />
            {/* space is reserved before the rows load (theme-pink.css .personal-rows-slot) */}
            <div className="personal-rows-slot"><PersonalRows mode="home" /></div>
            {/* Glamzy Lookbook's looks: each card opens its own look game */}
            <FashionHomeRow looks={fashion.looks} newSlugs={fashion.newSlugs} />
            <Game_Components rows={rows}/>
          <CatBtn />
          <HomeDis />
          <FooterDis />
          <CookieCom />
            </div>
          </div>

        </div>
      </div>
      <FooterCom />
      <Snow_fx />
    </>
  );
}
